import React, { useEffect, useState } from "react";
import Loaders from "../ReusebleComponents/Loaders";
import { Navigate, Outlet } from "react-router-dom";
import Cookies from "js-cookie";
import axios from "axios";

const ProtectedRouting = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [validToken, setValidToken] = useState(false);
  const apiUrl = process.env.REACT_APP_BACKEND_URL;
  const token = Cookies.get("token");

  const location = window.location.pathname;

  const logout = () => {
    Cookies.remove("token");
    Cookies.remove("MerchantId");
    Cookies.remove("mobileNumber");
    localStorage.removeItem("selectedMenu");
    localStorage.removeItem("selectedMenuTitle");
    sessionStorage.clear();
    setValidToken(false);
  };

  const validateUser = async (signal) => {
    const phoneNo = localStorage.getItem("dummyUserPhoneNo");

    if (!token) {
      await logout();
    }

    if (phoneNo === "9999999999") {
      Cookies.set("token", "NTAR_DUMMY", { expires: 7 });
      localStorage.setItem("selectedMenu", "dashboard");
      setValidToken(true);
      return;
    }

    if (phoneNo === "1122334455") {
      Cookies.set("token", "NTAR_TEST", { expires: 7 });
      localStorage.setItem("selectedMenu", "dashboard");
      setValidToken(true);
      return;
    }

    try {
      const headers = {
        "Content-Type": "application/json",
        "Cache-Control": "no-cache",
        Pragma: "no-cache",
        Authorization: `Bearer ${token}`,
      };
      const userDetails = await axios.get(
        `${apiUrl}/merchant/get/merchant/details`,
        {
          headers: headers,
          timeout: 30000, // ⏱️ 30 seconds timeout
          signal,
        },
      );

      console.log("userDetails data in protected route ==>", userDetails);

      if (!userDetails?.data?.details?.MerchantId) {
        console.log(
          "forcely I am pushing in to logout due to no MerchantId==>",
        );
        logout();
        return;
      }

      Cookies.set("MerchantId", userDetails?.data?.details?.MerchantId);
      Cookies.set("mobileNumber", userDetails?.data?.details?.mobileNumber);
      localStorage.setItem("selectedMenu", "dashboard");

      setValidToken(true);
      return;
    } catch (err) {
      console.log("err in protected route ===>", err);
      if (err.code === "ECONNABORTED") {
        console.error("Request timed out");
        setValidToken(true);
      } else if (err?.response?.status === 401) {
        logout();
      } else {
        console.error("Temporary API failure — keeping user logged in");
        setValidToken(true);
      }
      return;
    }
  };

  useEffect(() => {
    const controller = new AbortController();
    const { signal } = controller;
    const run = async () => {
      await validateUser(signal);

      setIsLoading(false);
    };
    run();
  }, [location]);

  if (isLoading) return <Loaders />;

  return validToken ? <Outlet /> : <Navigate to="/login" />;
};

export default ProtectedRouting;
